import ResetPassword from "../../components/reset-password/reset-password.component";

export default function ResetPasswordPage(){
    return <ResetPassword/>
}